import 'rc-tooltip/assets/bootstrap_white.css';
import React, { Component, PropsWithChildren, Fragment } from 'react';
import { FormGroup } from '..';
import { Button } from '../Button';
import { ModalBody } from '../Modal';
import { ModalFooter } from '../Modal';
import { ModalHeader } from '../Modal';
import { FilterContext } from './FilterContext';
import { IFilterSelectionProps, IFilterValues } from './types';

export interface IFilterSelectionState {
  values: IFilterValues;
}

export class FilterSelection extends Component<PropsWithChildren<IFilterSelectionProps>, IFilterSelectionState> {
  public readonly state: Readonly<IFilterSelectionState> = {
    values: this.props.values,
  };
  public handleFilterChange = (filterName: string, filterValue: any) => {
    const newValue = { [`${filterName}`]: filterValue };
    const newValues = {
      ...this.state.values,
      ...newValue,
    };
    this.setState({ values: newValues });
  };
  public handleFilterBatchUpdate = (filters: IFilterValues) => {
    const newValues = {
      ...this.state.values,
      ...filters,
    };
    this.setState({ values: newValues });
  };
  public handleClear = () => {
    const newValues = Object.keys(this.state.values).reduce<IFilterValues>((vals, valueName) => {
      vals[valueName] = '';
      return vals;
    }, {});
    this.setState({ values: newValues });
  };
  public handleApply = () => {
    this.props.onChange(this.state.values);
  };
  public render() {
    const { filters } = this.props;

    return (
      <Fragment>
        <ModalHeader closeButton={true} title="Filter" />
        <ModalBody>
          <FilterContext.Provider
            value={{
              batchUpdate: this.handleFilterBatchUpdate,
              handleChange: this.handleFilterChange,
              values: this.state.values,
            }}
          >
            {filters.map((Filter, i) => {
              return <FormGroup key={i}>{Filter}</FormGroup>;
            })}
          </FilterContext.Provider>
        </ModalBody>
        <ModalFooter>
          <Button color="default" label="Cancel" onClick={this.props.onCancel} />
          <Button color="default" label="Clear Filter" onClick={this.handleClear} />
          <Button color="primary" label="Apply" onClick={this.handleApply} />
        </ModalFooter>
      </Fragment>
    );
  }
}

export default FilterSelection;
